import { inputTypes } from '@easybutton/constants'

import { indexOf } from './arrays'

export const newAction = (name, step) => {
  return {
    name,
    details: {
      steps: [step],
    },
  }
}

export const replaceStep = (action, stepId, step) => {
  let steps = action.details.steps.slice()
  let index = indexOf(steps, step => step.id === stepId)

  if (index !== -1) {
    steps[index] = step
  } else {
    steps.push(step)
  }

  return {
    ...action,
    details: {
      ...action.details,
      steps,
    },
  }
}

export const getInput = (inputId, action) => {
  let inputs = (action && action.details && action.details.inputs) || []
  let input = inputs.filter(input => input && input.id === inputId)[0]

  return input
}

export const getViewActions = (view, actions) => {
  const { databaseId, table } = view.body

  const results = actions
    .map(action => ({
      action,
      input: (action.details.inputs || []).filter(
        input =>
          input.type === inputTypes.PRIMARY_KEY &&
          input.databaseId === databaseId &&
          input.table === table
      )[0],
    }))
    .filter(result => result.input)

  // Convert to label / value format

  return [
    {
      label: 'Actions',
      inline: true,
      children: results.map(result => ({
        label: result.action.name,
        value: result,
      })),
    },
  ]
}
